import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpimoxvjzq/layouts/custom.vue").then(m => m.default || m))
}